<template>
  <b-card border-variant="success" class="text-center">
    <div slot="header">
      {{ 'budget' | translate('global') }}
      <div class="card-header-actions">
        <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1
                @click="collapseOpen = !collapseOpen">
          <i v-if="collapseOpen" class="icon-arrow-up"></i>
          <i v-if="!collapseOpen" class="icon-arrow-down"></i>
        </b-link>
      </div>
    </div>
    <b-collapse id="collapse1" visible>
      <b-row>
        <b-col cols="4" xl="3">
          <b-form-group>
            <label>{{ 'january' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_01')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_01 }"
                          v-model="budget.budget_limit_01"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_01">
              {{ errorMsg.budget_limit_01[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label>{{ 'february' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_02')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_02 }"
                          v-model="budget.budget_limit_02"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_02">
              {{ errorMsg.budget_limit_02[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label>{{ 'march' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_03')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_03 }"
                          v-model="budget.budget_limit_03"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_03">
              {{ errorMsg.budget_limit_03[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label>{{ 'april' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_04')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_04 }"
                          v-model="budget.budget_limit_04"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_04">
              {{ errorMsg.budget_limit_04[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label>{{ 'may' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_05')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_05 }"
                          v-model="budget.budget_limit_05"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_05">
              {{ errorMsg.budget_limit_05[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'june' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_06')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_06 }"
                          v-model="budget.budget_limit_06"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_06">
              {{ errorMsg.budget_limit_06[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'july' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_07')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_07 }"
                          v-model="budget.budget_limit_07"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_07">
              {{ errorMsg.budget_limit_07[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'august' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_08')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_08 }"
                          v-model="budget.budget_limit_08"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_08">
              {{ errorMsg.budget_limit_08[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'september' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_09')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_09 }"
                          v-model="budget.budget_limit_09"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_09">
              {{ errorMsg.budget_limit_09[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'october' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_10')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_10 }"
                          v-model="budget.budget_limit_10"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_10">
              {{ errorMsg.budget_limit_10[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'november' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_11')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_11 }"
                          v-model="budget.budget_limit_11"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_11">
              {{ errorMsg.budget_limit_11[0] }}
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="4" xl="3">
          <b-form-group>
            <label class="text-center">{{ 'december' | translate('global') }}</label>
            <b-form-input type="number" min="0" :disabled="editable && !editable.includes('budget_limit_12')"
                          :class="{ 'is-invalid' : errorMsg.budget_limit_12 }"
                          v-model="budget.budget_limit_12"
                          @change="onInput()"/>
            <div class="invalid-feedback" v-if="errorMsg.budget_limit_12">
              {{ errorMsg.budget_limit_12[0] }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    editable: {
      type: Array,
    },
    limits: {
      type: Object,
    },
    errorMsg: {
      type: Object,
    }
  },
  data() {
    return {
      collapseOpen: true,
      budget: this.limits ? this.limits : {
        budget_limit_01: '',
        budget_limit_02: '',
        budget_limit_03: '',
        budget_limit_04: '',
        budget_limit_05: '',
        budget_limit_06: '',
        budget_limit_07: '',
        budget_limit_08: '',
        budget_limit_09: '',
        budget_limit_10: '',
        budget_limit_11: '',
        budget_limit_12: ''
      },
    };
  },
  methods: {
    onInput() {
      this.$emit('budgetLimit', this.budget);
    },
  },
};
</script>
